import React from 'react';
import { Link, Redirect } from 'react-router-dom';

import './General.css';
import './Homepage.css';
import { Container, Row } from 'reactstrap';
import playButton from '../images/playButton2.png';
import Header from './Header';
// import Footer from './Footer';

function HomePage() {
  const isAuthenticated = localStorage.getItem('uuid');
  return (
    <>
      {isAuthenticated ? (
        <Container fluid className="d-flex flex-column vh-100 vw-100 align-items-center">
          <Header />
          <Row className="d-flex vh-100 justify-content-center align-items-center">
            <Link to="/mainPagePlay">
              <img
                className="playbutton"
                src={playButton}
                alt="Boutton Play"
                height="300"
                width="300"
              />
            </Link>
          </Row>
          {/* <Row className="row-footer vw-100 justify-content-center align-items-center">
            <Footer />
          </Row> */}
        </Container>
      ) : (
        <Redirect to="/authentication" />
      )}
      {/* <button onClick={localStorage.clear()}>clear</button> */}
    </>
  );
}

export default HomePage;
